import { useReduxState } from 'hooks';
import { getFormattedDate } from 'lib/common';
import { TimeIndicator } from 'components/common';

interface Props {
  createdAt: string | Date;
  updatedAt: string | Date;
}

const EditedContent = ({ createdAt, updatedAt }: Props) => {
  const { language, messages } = useReduxState();

  const createdAtString = getFormattedDate({
    date: createdAt,
    dateFormat: 'dd.MM.y HH:mm'
  });

  const updatedAtString = getFormattedDate({
    date: updatedAt,
    dateFormat: 'dd.MM.y HH:mm'
  });

  return (
    <span>
      <span aria-label={createdAtString} data-tooltip={createdAtString}>
        <TimeIndicator language={language} timeString={createdAt as string} />
      </span>

      {updatedAt > createdAt ? (
        <span
          aria-label={`${messages.readerDiscussionCommentEdited} ${updatedAtString}`}
          data-tooltip={`${messages.readerDiscussionCommentEdited} ${updatedAtString}`}
        >
          {` (${messages.readerDiscussionCommentEdited})`}
        </span>
      ) : null}
    </span>
  );
};

export default EditedContent;
